import { Injectable } from '@angular/core';
import { MfsStorageProvider } from '@office-start/spaces-storage-service';

@Injectable({
    providedIn: 'root'
})
export class SpacesService {
    private _spacesStorageProvider: Promise<MfsStorageProvider>;

    public getSpacesStorageProvider(): Promise<MfsStorageProvider> {
        if (!this._spacesStorageProvider) {
            this._spacesStorageProvider = import(/*webpackChunkName: "spaces-storage-service" */ '@office-start/spaces-storage-service').then(
                mod => mod.getMfsStorageProvider()
                );
        }
        return this._spacesStorageProvider;
    }
}
